module.exports = __webpack_public_path__ + "img/refuge-example-image.68eba2cc.jpg";